/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Tag action type literals. Coming out from tag API tagAction method call
 */
export enum TagAction {

	// Request page session data that is used for IMA ad calls
	GET_SESSION_DATA = 'TagAction.GET_SESSION_DATA',

}